import api from '../api'

export default api.resource({
  path    : 'apps',
  keyName : 'id',
  schema  : {
    name: String
  }
})
